import API from "./api"; 

const ATTRIBUTE = "ai";


const Service = { 
    status:(ticket)=>{
        return new Promise((resolve, reject) => {
            API.get(`${ATTRIBUTE}/ticket/${ticket}`).then(
                result => {
                    resolve(result);
                },
                error => {
                    reject(error);
                }
            );
        });
    },
    newRequest: (item) => {
        return new Promise((resolve, reject) => {
            API.post(ATTRIBUTE , [], { item: item }).then(
                result => {
                    resolve(result)
                },
                error => {
                    reject(error);
                }
            );
        });
    }
}
export default Service;